<div class="bg-white flex flex-row border border-iota-outline">
    <div
        *ngFor="let tab of tabs"
        class="relative border-r last:border-r-0 border-r-iota-outline border-b border-b-white hover:border-b hover:border-b-primary flex flex-col justify-center pl-6 w-full h-[100px] gap-2 cursor-pointer transition"
        [ngClass]="{ '!border-b-[3px] !border-b-primary': tab?.key === selectedKey }"
        (click)="handleClick(tab)"
        (mouseenter)="startTooltipTimer(tab.key)"
        (mouseleave)="cancelTooltipTimer(tab.key)"
    >
        <span class="text-neutral text-sm" [ngClass]="{ '!text-primary': tab?.key === selectedKey }">{{ tab?.label }}</span>
        <span class="text-base-300 text-xl" [ngClass]="{ '!text-neutral': tab?.key === selectedKey }">{{ tab?.count }}</span>
        <div
            class="max-w-[180px] absolute tooltip tooltip-secondary leading-tight tooltip-left bottom-0 right-1 -mb-3 bg-iota-tooltip-bg text-[12px] text-white rounded-xl px-2 py-1"
            *ngIf="showTooltip[tab.key] && hasTooltip"
            (click)="$event.stopPropagation()"
        >
            {{ getTooltipText(tab.key) }}
        </div>
    </div>
</div>
